import { useQuery } from "@tanstack/react-query";
import axios from "../interseptor/axiosConf";



function fetchLatestCreated(){

    return axios.get(`/api/user/latest/created`).then(res => res.data);
}

export const useGetLatestCreated =()=>{

    return useQuery({
        queryKey: [`LatestCreated`],
        queryFn:()=> fetchLatestCreated(),
    });
}